export default __webpack_public_path__ + "static/media/question_well_config_B.a3a6ca68.jpg";